import Vue from 'vue'
import VueRouter from 'vue-router'
import {passport, baseHost} from "../plugins/host";
import Cookie from 'js-cookie'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'index',
      component: () => import('../views/index.vue'),
      meta:{title:"证件译 - 译问"}
    },
    {
      path: '/id_card',
      name: 'id_card',
      component: () => import('../views/id_card.vue'),
      meta:{title:"身份证翻译 - 译问", type: "loginVerification"}
    },
    {
      path: '/business_license',
      name: 'business_license',
      component: () => import('../views/business_license.vue'),
      meta:{title:"营业执照翻译 - 译问", type: "loginVerification"}
    }
]

const router = new VueRouter({
  mode: 'history',
  base: 'cert',
  routes
})

router.beforeEach((to,from,next)=>{
  if(to.meta.title){
    document.title = to.meta.title
  }
  const type = to.meta.type;
  // 页面需要登陆验证
  if (type == "loginVerification") {
    let token = Cookie.get('token');
    if (token) {
      next()
    } else {
      window.location.href = passport()+"/sign/?red="+baseHost()+to.fullPath
    }
  }else{
    next()
  }
})

export default router
